import { publishFormSubmitted } from 'utils/form-analytics';

const installContactFormListener = (): void => {
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const emailInput = form.querySelector<HTMLInputElement>('input[name="contact[email]"]');
      if (!emailInput) return;

      publishFormSubmitted('contact', emailInput.value, form.id || undefined);
    },
    true,
  );
};

installContactFormListener();
